// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

/**
 * Sprint 63.29.0 (#541) — where a session whose user must change their password
 * goes. One definition for the route, so the login page, `ProtectedRoute` and the
 * app's route table cannot drift apart (the shape of `utils/mfa-step-up.ts`).
 *
 * The server admits such a session to exactly three paths
 * (`passwordChangeHoldAllowedPaths()` in `middleware/auth.ts`):
 * `POST /auth/change-password`, `GET /auth/me` and `POST /auth/logout`. The page
 * at this route calls nothing else.
 */
export const PASSWORD_CHANGE_REQUIRED_ROUTE = '/password-change-required';
